import React from 'react';
import { Spin } from 'antd';
const S = (props) => {
  const { ...rest } = props;
  return <Spin {...rest} />;
};
export default S;
